import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AccordionItemPromptWrapper, AccordionItemTitle, AccordionItemArrow, ArrowDownIcon } from "./AccordionItem.styles";
export var AccordionItemPrompt = function(param) {
    var prompt = param.prompt;
    return /*#__PURE__*/ _jsxs(AccordionItemPromptWrapper, {
        children: [
            /*#__PURE__*/ _jsx(AccordionItemTitle, {
                as: "span",
                children: prompt
            }),
            /*#__PURE__*/ _jsx(AccordionItemArrow, {
                children: /*#__PURE__*/ _jsx(ArrowDownIcon, {})
            })
        ]
    });
};
